import React from "react";

import { LargeButton, BUTTON_TYPES } from "app/interaction/LargeButton/LargeButton";

export interface Props {
    title: string;
    url: string;
    rel?: string;
    arrow?: boolean;
    type?: BUTTON_TYPES;
    className?: string;
}

export const LinkButton = ({ title, url, rel, arrow, className, type = BUTTON_TYPES.PRIMARY }: Props) =>
    LargeButton({ children: title, arrow, href: url, rel, className, type });
